import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../../../Resources/Translations';

interface AddToCartErrorProps {
    children: React.ReactNode;
    closeErrorMessage: () => void;
    canBeClosed?: boolean;
    isError?: boolean;
    className?: string;
    icon?: React.ReactNode;
}

export const AddToCartMessage = ({ isError, canBeClosed, closeErrorMessage, children, className, icon }: AddToCartErrorProps) => {
    return (
        <div className={classNames('AddToCartMessage', isError && 'AddToCartMessage--Red', className)}>
            {icon && <span className="AddToCartMessage__Icon">{icon}</span>}
            <div className={classNames('AddToCartMessage__Inner', canBeClosed && 'AddToCartMessage__Inner--WithCloseButton')}>{children}</div>
            {canBeClosed && (
                <button className="AddToCartMessage__Button" onClick={closeErrorMessage}>
                    <span className="visuallyHidden">{getTranslation(keys['addToCart.close'])}</span>
                </button>
            )}
        </div>
    );
};
